import { FilterMatchMode } from "primereact/api";

export class DetalleCliente {

    model = {
        id: {
            value: null,
            export: true,
            header: 'Código',
            table: false,
            filter: true,
            filterPlaceholder: 'Buscar por código',
            filterField: 'id',
            sort: true,
            matchMode: FilterMatchMode.EQUALS,
            showFilterMatchModes: false,
            headerStyle: { width: '10%', minWidth: '10rem' }
        },
        nombre_completo: {
            value: '',
            export: true,
            header: 'Nombre completo o razón social',
            table: true,
            sort: false,
            filter: true,
            headerStyle: { width: '30%', minWidth: '20rem' },
            filterPlaceholder: 'Buscar',
            filterField: 'nombre_completo',
            matchMode: FilterMatchMode.CONTAINS
        },
        tipo_identificacion: {
            value: null,
            export: false,
            header: 'Tipo de documento:',
            required: 'Tipo de formulario es requerido'
        },
        identificacion: {
            value: '',
            export: false,
            header: 'Cédula de identidad / Ruc:',
            required: 'Identificación es requerido',
            maxLength: 'Máximo 50 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 50,
            min: 4,
            filterField: 'identificacion',
            filterPlaceholder: 'Buscar por número de identificación',
            table: true,
            filter: false,
            sort: true
        },
        telefono: {
            value: '',
            export: false,
            header: 'Teléfono:',
            maxLength: 'Máximo 40 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 40,
            min: 4,
            required: 'Teléfono es requerida'
        },
        cliente_desde: {
            value: new Date(),
            export: false,
            header: 'Cliente desde(día/mes/año):',
            required: 'Fecha es requerido',
            table: true,
            sort: true,
            headerStyle: { width: '10%', minWidth: '10rem' }
        },

    }
}